// JavaScript source code
import React, { useState, useEffect, useRef} from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
import EasyZoom from '../components/imageEasyZoom';
import Cart from '../components/cart';
import LoadingOverlay from '../components/loadingOverlay';
import MessageDialog from '../components/messageDialog';
import LoginDialog from '../components/loginDialog';
import { get, getUser,  getCart,saveCart} from '../request';
import Button from '../components/button';
import noImage from '../assets/images/mall/nopic.png'
import config from '../config';
function Product(props) {
    const activeIndex = 2;
    const location = useLocation();
    let params = new URLSearchParams(location.search);
    const id = params.get('id');
    const authorization = localStorage.getItem("Authorization");
    var user = getUser();
    const showPrice = authorization !=null && user != null && user.userType == 1 && user.business.businessStatus == 0;
    const navigate = useNavigate();
    const imageRef = useRef(null); // 创建一个 ref 来引用 img 元素  
    var currentDId;
    if (user && user.canBuyDepartmentIds && user.canBuyDepartmentIds.length > 0) {
        if (localStorage.getItem("currentDId") && localStorage.getItem("currentDId") !="null") {
            currentDId = localStorage.getItem("currentDId");
            localStorage.setItem("currentDId", null);
        }
        else {
            currentDId = user.canBuyDepartmentIds[0].id; //23,24,25
        }
    }
    const [product, setData] = useState({}); // 初始化数据状态为null
    const [productImage, setProductImage] = useState(""); // 初始化数据状态为null


    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [quantity, setQuantity] = useState(1);
    const [productSku, setProductSku] = useState({});
    const [imgShowIndex, setImgShowIndex] = useState(0);
    const [cartlist, setCartlist] = useState([]);
    const [isLoading, setShowLoading] = useState(false);
    const [isShowLogin, setIsShowLogin] = useState(false);

    const [finalPrice, setFinalPrice] = useState(0);
    const [finalServicePrice, setFinalServicePrice] = useState(0);
    const [isCanPoints, setIsCanPoints] = useState(false);
    const [productName, setProductName] = useState("");
    const [imgDivStyle, setImgDivStyle] = useState({left:0});
    const [leftDisabled, setLeftDisabled] = useState(true);
    const [rightDisabled, setRightDisabled] = useState(true);

    useEffect(() => {
        getProduct();
        refreshBuy();

    }, []);
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const calcTotalPrice =()=> {
        var buyItems = {
            skus: [],
            price: 0
        };
        //计算总价
        var totleprice = 0;
        var productCount = 0;
        for (var i = 0; i < cartlist.length; i++) {
            var productSku = cartlist[i];
            if (productSku.sum == 0) {
                productSku.sum = 1;
            }
            totleprice += productSku.sku.servicePrice * productSku.sum;
            productCount += productSku.sum;
            var sku = { skuId: productSku.skuId, sku: productSku, sum: productSku.sum };
            buyItems.skus.push(sku);
        }
        buyItems.price = totleprice;
        //storage.set('buy-items', JSON.stringify(buyItems));
        //setTotleprice(buyItems.price.toFixed(2));
    }
    const getProduct = () => {
        setShowLoading(true);
        var my = showPrice ? "my" : "";
        if (id) {
            get('delianapi/product/' + my + 'web/' + id).then((response) => {
                setShowLoading(false);
                var product = response.items[0];
                product.categoryName = product.categoryName.split('>').join('');
                product = setPrice(product);
                //product = setProductPropertyList(product);
                product = initProductPropertyValueList(product);
                product.nameHtml = { __html: product.name };
                setData(product);
                var detail = product.productDetailList.filter(function (de) {
                    return de.detailType == 3;
                });
                if (detail.length > 0) {
                    setProductImage(detail[0].productDetailImageUrl);
                }
                for (var i = 0; i < product.productImageList.length; i++) {
                    var productImage = product.productImageList[i];
                    if (productImage.imageUrl) {
                        productImage.image = new Image();
                        productImage.image.crossOrigin = "Anonymous";
                        productImage.image.onload = function () {
                            this.base64 = getBase64Image(this);
                        }
                        productImage.image.src = productImage.imageUrl + ".small.png";
                    }
                }
                for (var i = 0; i < product.productSkuList.length; i++) {
                    var productImage = product.productSkuList[i];
                    if (productImage.imageUrl) {
                        productImage.image = new Image();
                        productImage.image.crossOrigin = "Anonymous";
                        productImage.image.onload = function () {
                            this.base64 = getBase64Image(this);
                        }
                        productImage.image.src = productImage.imageUrl + ".small.png";
                    }
                }
                setDisabel(product, 0);
                //setTimeout(function () {
                //    easyzoom = $(".easyzoom").easyZoom().data("easyZoom");
                //    $('.products').each(function (i, item) {
                //        if ($(item).children().length < 4) {
                //            $(item).closest(".small-list").find('.arrow.right').addClass('disabled');
                //        }
                //    });
                //    enableBtnRight();
                //    //默认选中第一个
                //    $(".choose-sku").each(function (n, div) {
                //        $($(div).find("a")[0]).click();
                //    });
                //}, 50);
            });
        }
    }
   
    const getProductImageIndex =(productSku)=> {
        if (productSku.image && productSku.image.base64) {
            for (var i = 0; i < product.productImageList.length; i++) {
                var productImage = product.productImageList[i];
                if (productImage.image && productImage.image.base64) {
                    if (productSku.image.base64 == productImage.image.base64) {
                        return i;
                    }
                }
            }
        }
        return -1;
    }

    const getBase64Image =(img)=> {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, img.width, img.height);
        var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
        var dataURL = canvas.toDataURL("image/" + ext);
        return dataURL;
    }
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    const refreshBuy =()=> {
        if (user != null && user.userType == 1 && user.business.businessStatus == 0) {
            getCart().then(function (response) {
                if (response.statusCode !== 200) {
                    localStorage.setItem('user', null);
                    return;
                }
                var list = response.items.filter(function (c) { return c.sku; });
                setCartlist(list );
            });
        }       
    }
    const setPrice =(product)=> {
        var prices = [];
        var servicePrices = [];
        for (var i = 0; i < product.productSkuList.length; i++) {
            if (product.productSkuList[i].isActive) {
                if (product.productSkuList[i].price != null) {
                    prices.push(product.productSkuList[i].price);
                }
                if (product.productSkuList[i].servicePrice != null) {
                    servicePrices.push(product.productSkuList[i].servicePrice);
                }
            }
        }
        product.minPrice = prices.length > 0 ? Math.min.apply(this, prices).toFixed(2) : null;
        product.maxPrice = prices.length > 0 ? Math.max.apply(this, prices).toFixed(2) : null;
        product.minServicePrice = servicePrices.length > 0 ? Math.min.apply(this, servicePrices).toFixed(2) : null;
        product.maxServicePrice = servicePrices.length > 0 ? Math.max.apply(this, servicePrices).toFixed(2) : null;
        return product;
    }

    const setProductPropertyList =(product)=>{
        var propertyArray = [];
        for (var i = 0, l = Math.ceil(product.productPropertyList.length / 2); i < l; i++) {
            var a = [product.productPropertyList[i * 2]];
            if (i * 2 + 1 < product.productPropertyList.length) {
                a.push(product.productPropertyList[i * 2 + 1]);
            } else {
                a.push({});
            }
            propertyArray.push(a);
        }
        product.propertyArray = propertyArray;
        return product;
    }

    const reCalSum =(sku, sum) =>{
        var minOrderQuantity = 1;
        var orderMultiple = 1;
        if (sku && sku.minOrderQuantity && sku.orderMultiple) {
            minOrderQuantity = sku.minOrderQuantity;
            orderMultiple = sku.orderMultiple;
        }
        sum = parseInt(sum) <= minOrderQuantity ? minOrderQuantity : parseInt(sum);
        if (sum % orderMultiple != 0) {
            sum = sum - sum % orderMultiple + orderMultiple;
        }
        return sum;
    }
    const handleQuantityChange = (event) => {
        // 使用replace方法移除非数字字符  
        const newValue = event.target.value.replace(/[^\d]/g, '');
        setQuantity(newValue);
    };
    const handleQuantityPaste = (event) => {
        // 阻止默认粘贴行为  
        event.preventDefault();
    };
    const minusQuantity =  () =>{
        var productSku = getSelectedProductSku();
        if (!productSku) { return; }
        setProductSku( productSku);
        var theQuantity = parseInt(quantity) <= productSku.minOrderQuantity ?
            productSku.minOrderQuantity :
            parseInt(quantity) - productSku.orderMultiple;
        theQuantity = reCalSum(productSku, theQuantity);
        setQuantity(theQuantity);
    };
    const addQuantity = ()=> {
        var productSku = getSelectedProductSku();
        if (!productSku) { return; }

        if (isNaN(quantity)) {
            setQuantity(1);
        }
        var theQuantity = parseInt(quantity) + 1;
        theQuantity = reCalSum(productSku, theQuantity);
        setQuantity(theQuantity);

    };
    const showImg = (index) => {
        setImgShowIndex(index);
        //if (easyzoom && easyzoom.swap) {
        //    easyzoom.swap(product.productImageList[index].imageUrl, product.productImageList[index].imageUrl);
        //}
    }
    const showImg2 = (productSku) => {
        var index = getProductImageIndex(productSku);
        if (index >= 0) {
            showImg(index);
            //goDirection(index);
        }
    }

    const getSelecedSku = ()=> {
        var sku = []; //所有选择的sku值
        if (product) {
            var selectSKU = product.productPropertyList.filter(function (item) {
                return item.isSku == 1;
            });
            for (var i = 0; i < selectSKU.length; i++) {
                for (var j = 0; j < selectSKU[i].productPropertyValueList.length; j++) {
                    if (selectSKU[i].productPropertyValueList[j].selected) {
                        sku.push(selectSKU[i].propertyId + ":" + selectSKU[i].productPropertyValueList[j].value);
                    }
                }
            }
        }
        return sku;
    }
    const chooseSku = (propertyvalue, property)=> {
        if (propertyvalue.isOutOfStock) {
            return;
        }
        if (propertyvalue.selected) {
            propertyvalue.selected = false;
            //isDoSelected = false;
        } else {
            property.productPropertyValueList.forEach(function (item) {
                item.selected = false;
            });
            propertyvalue.selected = true;
        }
        //动态修改按钮状态
        var sku = getSelecedSku();//所有选择的sku值
        //var propertyid = sku.id;
        //动态修改价格
        dealProductSKU();
        var temp = [];//所有可用sku
        for (var i = 0; i < product.productSkuList.length; i++) {
            var productSku = product.productSkuList[i];
            temp.push(productSku.sku.split('|'));
        }
        var judgeBuyItems = product.productPropertyList.filter(function (item) {
            return item.isSku == 1;
        });
        var tempAvible = []; //计算后可用sku
        for (var i = 0; i < judgeBuyItems.length; i++) { //遍历sku
            var items = judgeBuyItems[i].productPropertyValueList;
            var pid = judgeBuyItems[i].propertyId;
            //查找符合选择的sku
            var meetSkus = getMeetSku(sku, temp, pid);
            for (var m = 0; m < items.length; m++) { //遍历每项sku的值
                var itemsku = judgeBuyItems[i].propertyId + ":" + items[m].value;

                //不能选的css:out-of-stock
                var isMeet = false;
                for (var j = 0; j < meetSkus.length; j++) {
                    if (meetSkus[j].indexOf(itemsku) >= 0) {
                        isMeet = true;
                        break;
                    }
                }
                if (isMeet) {
                    items[m].isOutOfStock = false;
                } else {
                    items[m].isOutOfStock = true;
                    items[m].selected = false;
                }
            }
        }
    }
    const initProductPropertyValueList = (product) =>{
        var sku = [];//所有选择的sku值
        var temp = [];//所有可用sku
        for (var i = 0; i < product.productSkuList.length; i++) {
            var productSku = product.productSkuList[i];
            temp.push(productSku.sku.split('|'));
        }
        var judgeBuyItems = product.productPropertyList.filter(function (item) {
            return item.isSku == 1;
        });
        for (var i = 0; i < judgeBuyItems.length; i++) { //遍历sku
            var items = judgeBuyItems[i].productPropertyValueList;
            var pid = judgeBuyItems[i].propertyId;
            //查找符合选择的sku
            var meetSkus = getMeetSku(sku, temp, pid);
            for (var m = 0; m < items.length; m++) { //遍历每项sku的值
                var itemsku = judgeBuyItems[i].propertyId + ":" + items[m].value;

                //不能选的css:out-of-stock
                var isMeet = false;
                for (var j = 0; j < meetSkus.length; j++) {
                    if (meetSkus[j].indexOf(itemsku) >= 0) {
                        isMeet = true;
                        break;
                    }
                }
                if (isMeet) {
                    items[m].isOutOfStock = false;
                } else {
                    items[m].isOutOfStock = true;
                    items[m].selected = false;
                }
            }
        }
        for (var i = 0; i < judgeBuyItems.length; i++) { //遍历sku
            var items = judgeBuyItems[i].productPropertyValueList;
            judgeBuyItems[i].productPropertyValueList = items.filter(function (item) { return !item.isOutOfStock })
        }

        return product;
    }

    const getProperty = (propertylist)=> {
        var p = [];
        for (var i = 0; i < propertylist.length; i++) {
            p.push(propertylist[i].value);
        }
        return p.join('，');
    }
    const getSelectedProductSku =()=> {
        var skus = getSelecedSku();
        var productSku = null;
        if (skus.length > 0) {
            var sku = skus.join('|');
            var skuarray = getSelecedSkuName();
            var skuname = skuarray.join('|');
            if (product.productSkuList) {
                for (var i = 0; i < product.productSkuList.length; i++) {
                    if (product.productSkuList[i].sku == sku) {
                        productSku = product.productSkuList[i];
                        productSku.skuName = skuname;
                        break;
                    }
                }
            }
        }
        return productSku;
    }
    const buy = (type)=> {
        if (user == null || user.userType != 1 || user.business.businessStatus != 0) {
            alert("非商户登录，不能下单！").then(function () {
                setIsShowLogin(true);
            });
            return;
        }
        if (type == 1) {
            imdBuy();
        } else {
            //flyToCart(event);
            pushBuy();
        }
    }
    const getSelecedSkuName = () =>{
        var sku = []; //所有选择的sku值
        var selectSKU = product.productPropertyList.filter(function (item) {
            return item.isSku == 1;
        });
        for (var i = 0; i < selectSKU.length; i++) {
            for (var j = 0; j < selectSKU[i].productPropertyValueList.length; j++) {
                if (selectSKU[i].productPropertyValueList[j].selected) {
                    sku.push(selectSKU[i].productPropertyValueList[j].value);
                }
            }
        }
        return sku;
    }

    //查找符合选择的sku
    const getMeetSku = (selectSkuValue, allSku, propertyid)=> {
        var meetSkus = [];
        for (var j = 0; j < allSku.length; j++) {//遍历所有sku
            var isMeet = true;
            for (var l = 0; l < selectSkuValue.length; l++) {//遍历所有选择项目
                if (selectSkuValue[l].indexOf(propertyid + ':') >= 0) continue;
                if (allSku[j].indexOf(selectSkuValue[l]) < 0) {
                    isMeet = false;
                    break;
                }
            }
            if (isMeet) {
                meetSkus.push(allSku[j]);
            }
        }
        return meetSkus;
    }

    //分析所有sku，获得价格范围
    const getPriceRange = (productskulist)=>{
        var minPrice = 99999999;
        var maxPrice = -1;
        if (productskulist) {
            for (var i = 0; i < productskulist.length; i++) {
                var productSku = productskulist[i];
                if (productSku.servicePrice != null && productSku.servicePrice >= 0 && productSku.servicePrice < minPrice) minPrice = productSku.servicePrice;
                if (productSku.servicePrice != null && productSku.servicePrice >= 0 && productSku.servicePrice > maxPrice) maxPrice = productSku.servicePrice;
            }
        }
        return (maxPrice < 0) ? "暂无价格" : "¥ " + minPrice.toFixed(2) + " - " + maxPrice.toFixed(2);
    }
    const getOldPriceRange =  (productskulist)=> {
        var minPrice = 99999999;
        var maxPrice = -1;
        if (productskulist) {
            for (var i = 0; i < productskulist.length; i++) {
                var productSku = productskulist[i];
                if (!productSku.isPromotion) productSku.promotionPrevPrice = productSku.servicePrice;
                if (productSku.promotionPrevPrice != null && productSku.promotionPrevPrice < minPrice) minPrice = productSku.promotionPrevPrice;
                if (productSku.promotionPrevPrice != null && productSku.promotionPrevPrice > maxPrice) maxPrice = productSku.promotionPrevPrice;
            }
        }
        return (maxPrice < 0) ? "暂无价格" : "¥ " + minPrice.toFixed(2) + " - " + maxPrice.toFixed(2);
    }

    const getPriceRangeCustomPrice =  (productskulist) =>{
        var minPrice = 99999999;
        var maxPrice = 0;
        if (productskulist) {
            for (var i = 0; i < productskulist.length; i++) {
                var productSku = productskulist[i];
                if (productSku.price != null && productSku.price < minPrice) minPrice = productSku.price;
                if (productSku.price != null && productSku.price > maxPrice) maxPrice = productSku.price;
            }
        }
        return (maxPrice == 0) ? false : "¥ " + minPrice.toFixed(2) + " - " + maxPrice.toFixed(2);
    }

    //根据sku显示相应的价格/编码/图片
    const dealProductSKU =  ()=> {
        var productSku = getSelectedProductSku();
        setProductSku(productSku);

        if (productSku) {
            if (productSku.minOrderQuantity) {
                setQuantity(productSku.minOrderQuantity);
            } else {
                setQuantity(1);
            }
            if (productSku.servicePrice != null && productSku.servicePrice >= 0) {
                setFinalPrice(productSku.price == null ? 0 : productSku.price.toFixed(2));
                setFinalServicePrice(productSku.servicePrice.toFixed(2));
                //SpecialLogicFunc();

                setIsCanPoints(productSku.isCanPoints);
                setProductName({ __html: productSku.productName});
                //if ($('.old-final-price')) {
                //    if (productSku.isPromotion) {
                //        $('.old-final-price-span').show();
                //        $('.promotion-a').show();
                //        $('.final-price-span').html("促销价格：");
                //        $('.old-final-price').html("¥ " + productSku.promotionPrevPrice.toFixed(2));
                //    } else {
                //        $('.final-price-span').html("价格：");
                //        $('.old-final-price-span').hide();
                //        $('.promotion-a').hide();
                //    }
                //}
            }
            else {
                setFinalPrice(0);
                setFinalServicePrice(0);
                setData({ ...product,  ["minServicePrice"]: 0 });
                setProductName("");
                //$('.final-price').html("¥ " + "暂无价格");
                //if ($('.old-final-price')) {
                //    if (productSku.isPromotion) {
                //        $('.old-final-price-span').show();
                //        $('.promotion-a').show();
                //        $('.final-price-span').html("促销价格：");
                //        $('.old-final-price').html("¥ " + "暂无价格");
                //    } else {
                //        $('.final-price-span').html("价格：");
                //        $('.old-final-price-span').hide();
                //        $('.promotion-a').hide();
                //    }
                //}
            }
            //if (productSku.price) {
            //    $('.original-price').show();
            //    $('.original-price-title').show();
            //    $('.original-price').html("¥ " + productSku.price.toFixed(2));
            //} else {
            //    $('.original-price').hide();
            //    $('.original-price-title').hide();
            //}
            //$('.productSkuName').html(productSku.name);
            //$('.productSalesVolume').html(productSku.salesVolume);
            //$('.big-image').attr('src', productSku.imageUrl);
            //$scope.isOk = true;
            showImg2(productSku);

            setQuantity(reCalSum(productSku, quantity));

        } else {
            //$('.final-price').html(getPriceRange($scope.product.productSkuList));
            //if ($('.old-final-price')) {
            //    $('.old-final-price').html(getOldPriceRange($scope.product.productSkuList));
            //    $('.old-final-price-span').show();
            //    $('.promotion-a').show();
            //    $('.final-price-span').html("促销价格：");
            //}

            //var PriceRangeCustomPrice = getPriceRangeCustomPrice($scope.product.productSkuList);
            //if (PriceRangeCustomPrice) {
            //    $('.original-price').show();
            //    $('.original-price-title').show();
            //    $('.original-price').html(PriceRangeCustomPrice);
            //} else {
            //    $('.original-price').hide();
            //    $('.original-price-title').hide();
            //}
            //$scope.isOk = false;
            setFinalPrice(0);
            setFinalServicePrice(0);
            setProductName("");
            setQuantity(0);
        }

    }
    //加入购物车
    const pushBuy = ()=> {
        var productSku = getSelectedProductSku();
        setProductSku(productSku);

        if (productSku) {
            //检查数量
            var sum = parseInt(quantity);
            if (!productSku.minOrderQuantity) { productSku.minOrderQuantity = 1; }
            if (!productSku.orderMultiple) { productSku.orderMultiple = 1; }

            if (parseInt(sum) < productSku.minOrderQuantity) {
                setSuccessMessage('产品' + productSku.name + '数量' + sum + '小于最小起订量' + productSku.minOrderQuantity, "保存订单");
                return;
            }
            if (sum % productSku.orderMultiple != 0) {
                setSuccessMessage('产品' + productSku.name + '数量' + sum + '不是' + productSku.orderMultiple + '的倍数', "保存订单");
                return;
            }
            //var temp = storage.get('buy-items');
            //var buyItems = null;
            //if (temp && temp.match("^\{(.+:.+,*){1,}\}$")) buyItems = $.parseJSON(temp);
            //if (!buyItems) {
            //    buyItems = {
            //        skus: [],
            //        price: 0
            //    }
            //}
            var oldCartlist = [...cartlist];
            var sku = findBuyProduct(oldCartlist, productSku.id);
            if (sku) {
                sku.sum += parseInt(quantity);
            } else {
                sku = { skuId: productSku.id, sku: productSku, sum: parseInt(quantity) };
                //buyItems.skus.push(sku);
                oldCartlist.push(sku);
                setCartlist(oldCartlist);
            }
            calcTotalPrice();
            //storage.set('buy-items', JSON.stringify(buyItems));
            if (user != null && user.userType == 1 && user.business.businessStatus == 0) {
                saveCart(sku.skuId, sku.sum)
                //    .then(function () {
                //    refreshBuy();
                //});                
            }
        //    $scope.showBuy = false;
        //    $scope.hideBuy = true;
        }
    }

    //立即购买
    const imdBuy =  ()=> {
        var productSku = getSelectedProductSku();
        setProductSku(productSku);

        if (productSku) {
            //检查数量
            var sum = parseInt(quantity);
            if (!productSku.minOrderQuantity) { productSku.minOrderQuantity = 1; }
            if (!productSku.orderMultiple) { productSku.orderMultiple = 1; }

            if (parseInt(sum) < productSku.minOrderQuantity) {
                setSuccessMessage('产品' + productSku.name + '数量' + sum + '小于最小起订量' + productSku.minOrderQuantity, "保存订单");
                return;
            }
            if (sum % productSku.orderMultiple != 0) {
                setSuccessMessage('产品' + productSku.name + '数量' + sum + '不是' + productSku.orderMultiple + '的倍数', "保存订单");
                return;
            }

            var buyItems = {
                skus: [],
                price: 0
            }

            var sku = { skuId: productSku.id, sku: productSku, sum: parseInt(quantity) };
            buyItems.skus.push(sku);

            localStorage.setItem('order-items', JSON.stringify(buyItems));
            navigate(config.root + '/confirmorder');
        }
    }

    const findBuyProduct = (buyItems, skuId)=> {
        for (var i = 0; i < buyItems.length; i++) {
            var sku = buyItems[i];
            if (sku.skuId == skuId) return sku;
        }
        return null;
    }
    const goImage = (step) => {
        if (!product || !product.productImageList || product.productImageList.length <=6) {
            return;
        }
        var left = 0;
        var width = 60 + 15;
        left = imgDivStyle.left + width * step;
        //到底
        if (left < -(product.productImageList.length - 6) * width || left > 0) {
            setImgDivStyle({ left: 0 });
            setDisabel(product, 0);
            return;
        }        
        setImgDivStyle({ left: left });
        setDisabel(product, left);
    }

    const setDisabel = (product, left) => {
        var width = 60 + 15;
        if (product.productImageList.length <= 6) {
            setLeftDisabled(true);
            setRightDisabled(true);
        }
        else {
            if (left <= -(product.productImageList.length - 6) * width) {
                setLeftDisabled(false);
                setRightDisabled(true);
            } 
            else if (left >= 0) {
                setLeftDisabled(true);
                setRightDisabled(false);
            }
            else {
                setLeftDisabled(false);
                setRightDisabled(false);
            }
        }
    }
    return (
        <div className="mydelian productdetail" >
            <SubHeader activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="detail">
                    <div className="crumbs">
                        <Link to={`${config.root}/home `} >首页</Link> <i> / </i>
                        <Link to={`${config.root}/MallList?productType=1 `} >德联产品</Link> <i> / </i>
                        <Link to={`${config.root}/MallList?categoryId=${product.categoryId}`}
                            className="under-line" >{product.categoryName}</Link> <i> /
                        </i>
                        <span className="blue" dangerouslySetInnerHTML={product.nameHtml} ></span>
                    </div>                   
                    
                    <div className="product">
                        <div className="productContent">
                            {
                                screenSize > 991 ? (
                                    <div className="imgs">
                                        <div className="big">
                                            <EasyZoom imageUrl={product.productImageList && product.productImageList.length > 0 ?
                                                product.productImageList[imgShowIndex].imageUrl.replace('.jpg', '.png')
                                                : ''} />
                                        </div>
                                        <div className="small-list">
                                            <div className={`arrow left ${leftDisabled ? 'disabled' : ''}`} onClick={() => goImage(1)}></div>
                                            <div className={`arrow right ${rightDisabled ? 'disabled' : ''}`} onClick={() => goImage(-1)}></div>

                                            <div className="products">
                                                <div className="imgDiv" style={imgDivStyle}>
                                                    {
                                                        product.productImageList && product.productImageList.map((image, index) => (
                                                            <img key={image.id} className="productImage"
                                                                src={image.imageUrl.replace('.jpg', '.png')}
                                                                onClick={() => showImg(index)} className={imgShowIndex == index ? 'active' : ''} alt="" />

                                                        ))
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                ): (
                                        <div className="imgs">
                                            {
                                                product.productImageList && (
                                                    <Swiper
                                                        modules={[Navigation]}
                                                        spaceBetween={0}
                                                        slidesPerView={1}
                                                        loop={true}
                                                        autoplay={{ delay: 10000, disableOnInteraction: false }}
                                                        pagination={{ el: '.swiper-pagination', clickable: true }}
                                                        speed={1000}
                                                        navigation
                                                    >
                                                        {
                                                            product.productImageList.map((img, index) => (
                                                                <SwiperSlide key={index}>
                                                                    <div className="slider-about">
                                                                        <div className="overlay">
                                                                            <img src={img.imageUrl.replace('.jpg', '.png')} />
                                                                        </div>
                                                                    </div>
                                                                </SwiperSlide>
                                                            ))
                                                        }
                                                        <div className="swiper-pagination" slot="pagination"></div>
                                                    </Swiper>)
                                            }
                                    </div>
                        )
                    }                    
                    <div className="infos">
                            <div className="name" dangerouslySetInnerHTML={productName ? productName : product.nameHtml} >
                        </div>
                                <div className="price-container">
                                    <div className="service-price">
                                        {
                                            showPrice && (product.minServicePrice > 0 || finalServicePrice > 0) &&
                                            <dt >
                                                <small >{product.isCanPoints ? '' : '￥'}</small>
                                                {!finalServicePrice && <span >{product.minServicePrice}</span>}
                                                {!finalServicePrice && <span >-</span>}
                                                {!finalServicePrice && <span >{product.maxServicePrice}</span>}
                                                {finalServicePrice > 0 && <span >{finalServicePrice}</span>}
                                            </dt>
                                        }
                                        {
                                            (!showPrice || (product.minServicePrice <= 0 && finalServicePrice <= 0)) &&
                                            <dt className="fs-20">
                                                暂无价格
                                            </dt>
                                        }

                                    </div>
                            {
                                showPrice && (product.minServicePrice > 0 || finalPrice > 0) &&
                                <div className="price">
                                    <dt>
                                        <small>￥</small>
                                        {!finalPrice && <span >{product.minPrice}</span>}
                                        {!finalPrice && <span >-</span>}
                                        {!finalPrice && <span >{product.maxPrice}</span>}
                                                {finalPrice > 0 && <span >{finalPrice}</span>}
                                                <small>（零售价）</small>

                                    </dt>
                                </div>
                            } 
                        </div>
                        <div className="choose">                           
                                    {product.productPropertyList && product.productPropertyList.map((property, index) => {
                                        if (property.isSku == 1) {
                                            return (
                                                <div className="choose-sku" key={property.id}>
                                                    <label>选择<span>{property.displayName}</span>：</label>
                                                    {
                                                        property.productPropertyValueList.map((propertyValue, index) => (
                                                            <div key={propertyValue.id} onClick={()=>chooseSku(propertyValue, property)}
                                                                className={`chooseSku ${propertyValue.selected ? "active" : ""} ${propertyValue.isOutOfStock ? 'out-of-stock' : ''}`}>
                                                                {propertyValue.value}
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            );
                                        }
                                        return null;
                                    })}
                            <div className="quantity">
                                        <label>购买数量：</label>
                                        <div className="quantityOperate">
                                            <button className="operate minus" onClick={minusQuantity}>-</button>
                                            <input value={quantity} onChange={handleQuantityChange}
                                                onPaste={handleQuantityPaste} />
                                            <button className="operate add" onClick={addQuantity}>+</button>
                                </div>
                                {
                                    productSku &&
                                    <label className="info" >
                                        起订量/幅度：{productSku.minOrderQuantity}/{productSku.orderMultiple}
                                    </label>
                                }
                            </div>
                            <div className="service">
                                        <label>售后保障：</label>
                                        <div className="serviceicon">
                                            <div className=" zheng">
                                                正品行货</div>
                                            <div className=" tui">
                                                退换货保证</div>
                                            <div className=" serv">
                                                客服保证</div>
                                </div>
                            </div>
                            <div className="buttons">
                                        <Button className={`btn btn-yellow ${!finalServicePrice || isCanPoints ?'disabled':''}`}
                                            disabled={!finalServicePrice || isCanPoints}
                                            onClick={() => buy(0)} title="加入购物车" />
                            </div>
                        </div>
                            </div>
                        </div>
                        <div className="productDetail">
                            <div className="productDetailTitle">
                                产品介绍
                            </div>
                            <div className="productDetailImage">
                                {
                                    productImage && <img src={productImage} />
                                }
                                {
                                    !productImage && <img src="https://www.delianac.com/delianacnew/static/media/nopic.e3e683f69eb891076916.png" />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
            {
                showPrice  &&
                <Cart num={cartlist.length} />
            }
            <SubFooter />
            <MessageDialog message={successMessage || errorMessage} onCancel={() => {
                setSuccessMessage("");
                setErrorMessage("");
            }} />
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
        </div>          
    );
}
export default Product;